module.exports = __webpack_public_path__ + "static/media/phoenixrehoming-light.36bdbc66.png";